// extracted by mini-css-extract-plugin
export var buttons = "_a2-0";
export var buttonsActive = "_a2-h";
export var cancelConfirm = "_a2-1";
export var closeButton = "_a2-2";
export var column = "_a2-3";
export var container = "_a2-4";
export var detailHeader = "_a2-6";
export var detailTitle = "_a2-7";
export var detailsContent = "_a2-5";
export var header = "_a2-8";
export var headerWithClose = "_a2-9";
export var icon = "_a2-a";
export var infoIcon = "_a2-c";
export var informationContainer = "_a2-b";
export var sideDrawer = "_a2-d";
export var sideDrawerOpen = "_a2-e";
export var stickyFooter = "_a2-f";
export var typeOption = "_a2-g";